import type { GetTrendingHashtags200HashtagsItem } from './getTrendingHashtags200HashtagsItem';

export type GetTrendingHashtags200 = {
  hashtags?: GetTrendingHashtags200HashtagsItem[];
  updatedAt?: string;
};
